import { useEffect, useState } from "react";
import { blogImageFallback } from "@/data/blog/images";

interface BlogImageProps {
  src: string;
  alt: string;
  title?: string;
  className?: string;
}

/**
 * Article image with a graceful fallback.
 * If an image ever fails to load, a neutral on-brand medical visual is shown
 * instead of a broken-image icon, so the listing and article pages never break.
 */
export default function BlogImage({ src, alt, title, className = "" }: BlogImageProps) {
  const [current, setCurrent] = useState(src || blogImageFallback);

  useEffect(() => {
    setCurrent(src || blogImageFallback);
  }, [src]);

  return (
    <img
      src={current}
      alt={alt}
      title={title}
      className={className}
      onError={() => {
        if (current !== blogImageFallback) {
          setCurrent(blogImageFallback);
        }
      }}
    />
  );
}